let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4PQpn")).then(() => parcelRequire('5JgnE'));